import Grid from "@mui/material/Grid";
import { useState } from "react";
import MDBox from "components/MDBox";
import { useDispatch, useSelector } from "react-redux";
import MDSnackbar from "components/MDSnackbar";
import LprDataFilterByDate from "./lprDataFilterByDate";
import LprDataSeacrch from "./lprDataSearch";
import LprTable from "./lprTable";
import { FormControl } from "@mui/material";
import Statistics from "./Statistics";

function LprStatistics() {
  const placesData = useSelector((state) => state.places?.selectedPlace);
  let placeId = placesData?._id;
  const tz = placesData?.timeZoneId || "America/Los_Angeles";
  const lprStatistics = useSelector(
    (state) => state.lprStatistic.statistics || {}
  );
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });
  const [filterOptions, setFilterOptions] = useState({
    placeId,
    startDate: "",
    endDate: "",
    search: "",
    tz,
  });

  return (
    <MDBox>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <LprDataFilterByDate
                filterOptions={filterOptions}
                setFilterOptions={setFilterOptions}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <LprDataSeacrch
                filterOptions={filterOptions}
                setFilterOptions={setFilterOptions}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Statistics data={lprStatistics} />
          </Grid>
          <Grid item xs={12}>
            <MDBox p={2}>
              <LprTable
                isLoading={false}
                placeId={placeId}
                startDate={filterOptions.startDate}
                endDate={filterOptions.endDate}
                searchText={filterOptions.search}
                tz={tz}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
    </MDBox>
  );
}

export default LprStatistics;
